/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PaymentsStore from '../../stores/PaymentsStore';

const PaymentMethodsLogos = (props) => {
  const { active, termsData } = props;
  //
  if (active) {
    return null;
  }
  //
  const paymentMethods = PaymentsStore.getMethods();
  if (!paymentMethods.length) {
    return null;
  }

  //
  const region = get(globals, 'region', '');
  const staticImageUri = get(globals, 'staticImageUri', '/');

  //
  const images = {
    banklink: 'swedbank_46h_gs.png',
    ibanka: 'seb_46h_gs.png',
    inordea: 'luminor_46h_gs.png',
    citadele: 'citadele_46h_gs.png',
    paypal: 'paypal_46h_gs.png',
    paysera: 'paysera_46h_gs.png',
    card: 'cards_46h_gs.png',
    sms: {
      lv: 'sms_bubble_46h_v2.png',
    },
  };
  //
  const paymentImage = (adapter) => images[adapter] || images[adapter.split('_')[0]];

  // SMS
  let sms = false;
  Object.values(termsData).forEach((term) => {
    if (term && term.type === 'sms') {
      sms = true;
    }
  });

  // Banks, cards
  const banks = [];
  const cards = [];
  paymentMethods.forEach((method) => {
    //
    if (method.adapter === 'paysera' && !isEmpty(method.methodList)) {
      //
      if (Object.prototype.hasOwnProperty.call(method.methodList, 'eBanking')) {
        Object.values(method.methodList.eBanking).forEach((m) => {
          banks.push(<img
            key={`pta_${m.key}`}
            src={m.logo}
            alt={m.title}
          />);
        });
      }
      //
      if (Object.prototype.hasOwnProperty.call(method.methodList, 'eMoney')) {
        Object.values(method.methodList.eMoney).forEach((m) => {
          cards.push(<img
            key={`pta_${m.key}`}
            src={m.logo}
            alt={m.title}
          />);
        });
      }
      return;
    }
    //
    const image = (
      <img
        key={`pta_${method.adapter}`}
        src={`${staticImageUri}${paymentImage(method.adapter)}`}
        alt={method.adapter}
      />
    );
    //
    if (method.type.substring(0, 2) === 'i_') {
      banks.push(image);
    } else {
      cards.push(image);
    }
  });

  return (
    <div>
      <div className="paymentFooter-logos">
        {sms && (
          <div className="paymentFooter-sms mrxs">
            <img
              src={`${staticImageUri}${Object.prototype.hasOwnProperty.call(images.sms, region) ? images.sms[region] : 'sms_46h.png'}`}
              alt="sms"
            />
          </div>
        )}
        {banks.length > 0 && (
          <div className="paymentFooter-banks">{banks}</div>
        )}
        {cards.length > 0 && (
          <div className="paymentFooter-cards">{cards}</div>
        )}
      </div>
    </div>
  );
};

PaymentMethodsLogos.propTypes = {
  termsData: PropTypes.instanceOf(Object).isRequired,
  active: PropTypes.string,
};
PaymentMethodsLogos.defaultProps = {
  active: null,
};

export default PaymentMethodsLogos;
